import gql from 'graphql-tag';
import collegeEventFilterFragment from '../../CollegeEventsEditEvent/graphql/collegeEventFilterFragment';

export default gql`
  mutation renameCollegeEventFilter($input: renameCollegeEventFilterInput!) {
    renameCollegeEventFilter(input: $input) {
      collegeEventFilter {
        ...CollegeEventFilter
        version
        publishedCollegeEventCount
        expiredCollegeEventCount
        unpublishedCollegeEventCount
        filterMatches
      }
      viewer {
        id
        eventFilters {
          ...CollegeEventFilter
          version
          publishedCollegeEventCount
          expiredCollegeEventCount
          unpublishedCollegeEventCount
          filterMatches
        }
      }
    }
  }
  ${collegeEventFilterFragment}
`;
